import {
  PLATFORM_NAV_PATHS,
  PRINT_STORE_PATHS
} from '@dtx-company/true-common/src/constants/layout'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useMediaQuery } from '@mui/material'
import { useRouter } from 'next/router'
import { useTheme } from '@mui/system'

const DESKTOP_LEFT_SIDE_DRAWER_PATHS = [
  Routes.CODES,
  Routes.CODE,
  Routes.PAGES,
  Routes.TRASH,
  Routes.ASSETS,
  Routes.ARCHIVE_ASSETS,
  Routes.FOLDERS,
  Routes.CRM_FORMS,
  Routes.BUNDLES,
  Routes.TEMPLATES_DISCOVER,
  Routes.TEMPLATES_DISCOVER_CODES,
  Routes.TEMPLATES_DISCOVER_PAGES,
  Routes.TEMPLATES_DISCOVER_PLACEMENTS,
  Routes.TEMPLATES_YOUR_TEMPLATES,
  Routes.TEMPLATES_YOUR_CODES,
  Routes.TEMPLATES_YOUR_PAGES,
  Routes.TEMPLATES_YOUR_CREATE,
  Routes.SEARCH_RESULTS,

  // ANALYTICS ROUTES
  Routes.ANALYTICS,
  Routes.ANALYTICS_CODES,
  Routes.ANALYTICS_CONVERSIONS,
  Routes.ANALYTICS_PAGES,
  Routes.ANALYTICS_PAGE,
  Routes.PIXEL_MANAGEMENT,
  Routes.REPORTS,
  Routes.REPORT,
  Routes.ANALYTICS_EVENTS,
  Routes.ANALYTICS_INSIGHTS,

  //STUDIO ROUTES
  Routes.STUDIO,
  Routes.AUTO,
  Routes.CODEE,
  Routes.STUDIO_TEMPLATES,
  Routes.STUDIO_COMPONENTS,
  Routes.STUDIO_LIBRARY,
  Routes.EDIT_STUDIO,
  Routes.INTERNAL_TOOLS,
  Routes.BRAND_KIT
]

export interface UseShouldShowV3DesktopNavigationType {
  shouldMountNavigationRail: boolean
  shouldMountLeftSideDrawer: boolean
  navigationRailMountShouldOverride: boolean
  shouldMountTopNav: boolean
  hideSiteNavsForEditor: boolean
}

export const useShouldShowV3DesktopNavigation = (): UseShouldShowV3DesktopNavigationType => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { pathname, query } = useRouter()
  const { isAuthenticated } = useAuthState()
  const onCodeDetailsPage = pathname === Routes.CODE && Boolean(query.batchId)

  const onLeftSideDrawerPath =
    DESKTOP_LEFT_SIDE_DRAWER_PATHS.includes(pathname as Routes) && !onCodeDetailsPage
  const currentPageIsPlatformRoute = PLATFORM_NAV_PATHS.includes(pathname as Routes)
  const shouldMountNavigationRail = isDesktop && currentPageIsPlatformRoute && isAuthenticated
  const shouldMountLeftSideDrawer = isDesktop && onLeftSideDrawerPath && isAuthenticated
  const navigationRailMountShouldOverride =
    shouldMountNavigationRail &&
    PRINT_STORE_PATHS.concat(Routes.SHOPPING_CART).includes(pathname as Routes) &&
    isAuthenticated
  const shouldMountTopNav = isDesktop
  const hideSiteNavsForEditor = false //leaving this for possible future experimentation - RB
  return {
    shouldMountNavigationRail,
    shouldMountLeftSideDrawer,
    navigationRailMountShouldOverride,
    shouldMountTopNav,
    hideSiteNavsForEditor
  }
}
